import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Router, RouterStateSnapshot } from "@angular/router";
import { Observable, tap } from "rxjs";
import { Store } from "@ngrx/store";
import { State } from "../store";
import { loadProfile } from "../store/profile/profile.actions";
import { logout, setSessionConfirm } from "../store/account/account.actions";
import { AlertService } from "src/app/shared/services/alert.service";
import { MessageService } from "primeng/api";
import { environment } from "../../../environments/environment";
import { MiniProfilerService } from "../services/mini-profiler.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  timer;
  constructor(
    private store: Store<State>,
    private alertService: AlertService,
    private messageService: MessageService,
    private router: Router,
    private profiler: MiniProfilerService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser && currentUser.token) {
      // add authorization header with jwt token if available
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          // update the token with the new one generatd on every request to increase the expiration to more 2 hours
          const newToken = evt.headers.get("newtoken");
          if (newToken) {
            const Expires = new Date(evt.headers.get("Expires"));
            currentUser = JSON.parse(localStorage.getItem("currentUser"));
            if (Expires && currentUser && currentUser.token !== newToken) {
              console.info(
                "JWT interceptor Refresh " + evt.headers.get("Expires"),
                Expires,
                newToken
              );
              currentUser.expires = Expires;
              currentUser.token = newToken;
              localStorage.setItem("currentUser", JSON.stringify(currentUser));
            }
          }

          this.timerAutoLogout();

          if (!environment.production) {
            // https://github.com/MiniProfiler/dotnet/issues/502

            try {
              const miniProfilerIds = evt.headers.get("X-MiniProfiler-Ids");
              if (miniProfilerIds) {
                this.profiler.fetch(JSON.parse(miniProfilerIds));
              }
            } catch (err) {}
          }
        }
      })
    );
  }

  timerAutoLogout() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      var currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!currentUser) {
        clearTimeout(this.timer);
        return;
      }

      var expiration = new Date(currentUser.expires);
      var currentTime = new Date();
      var ctUTC = currentTime;
      var remTime = Number(expiration) - Number(ctUTC);

      var sessConfirmVisible = false;
      this.store
        .select((s) => s.accountState.sessionConfirmVisible)
        .subscribe((res) => {
          sessConfirmVisible = res;
        });
      if (remTime <= 0) {
        console.info(
          "JWT Interceptor Expired at " + currentUser.expires,
          remTime,
          expiration
        );
        this.store.dispatch(logout());
        //this.store.dispatch(loadProfile());
        var url = this.router.routerState.snapshot?.url;

        this.router.navigate(["/login"], {
          queryParams: { returnUrl: url, timeoutAt: currentUser.expires },
        });

        this.store.dispatch(setSessionConfirm({ isVisible: false }));
        this.messageService.clear("confirmToat");
        this.alertService.info("Your session expired");
      } else if (remTime < 300000 && sessConfirmVisible == false) {
        this.alertService
          .confirm(
            "Session Expiring",
            "You have been inactive for more than 25 minutes. Would you like to continue? If no response is given you will be logged out."
          )
          .subscribe((res) => {
            if (res) {
              this.store.dispatch(loadProfile());
              this.store.dispatch(setSessionConfirm({ isVisible: false }));
            } else {
              this.store.dispatch(logout());
              this.store.dispatch(loadProfile());
              this.store.dispatch(setSessionConfirm({ isVisible: false }));
            }
          });
        this.store.dispatch(setSessionConfirm({ isVisible: true }));
      }

      this.timerAutoLogout();
    }, 10000);
  }

  parseToUTCDate(expires) {
    // Split the date and time components
    const [datePart, timePart, meridian] = expires.split(" ");

    // Split the date into month, day, and year
    const [month, day, year] = datePart.split("/").map(Number);

    // Split the time into hours, minutes, and seconds

    let [hours, minutes, seconds] = timePart.split(":").map(Number);

    // Adjust hours based on AM/PM
    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }

    // Create a Date object in UTC
    const utcDate = new Date(
      Date.UTC(year, month - 1, day, hours, minutes, seconds)
    );

    return utcDate;
  }
}
